
import { Vue, Prop } from 'vue-property-decorator';
import _ from 'lodash';

import AppVue from '@/AppVue.vue';
import { Validatable } from '@/core/models';

export default class BaseInputComponent extends AppVue {
  @Prop() model: Validatable;
  @Prop() prop: string;
  @Prop() label?: string;
  @Prop() placeholder?: string;
  @Prop({ default: false }) disabled: boolean;
  @Prop({ default: '' }) tooltipContent: string;
  @Prop({ default: false }) required: boolean;
  @Prop() hiddenLabel?: string;

  get internalLabel() {
    return this.required ? `${this.label} *` : this.label;
  }

  get internalHiddenLabel() {
    return this.hiddenLabel && this.required ? `${this.hiddenLabel} *` : this.hiddenLabel;
  }
  get isError() {
    return !!this.validationMessage;
  }

  get validationMessage() {
    if (!this.prop || !this.model || !this.model.modelState) {
      return '';
    }

    const messages = this.model.modelState[this.prop];

    if (!messages || messages.length === 0) {
      return '';
    }

    return messages[0] || '';
  }

  onChange(value: any) {
    this.$emit('change', value);

    if (!this.prop || !this.model || !this.model.modelState) {
      return;
    }

    this.model.modelState[this.prop] = null as any;
  }
}
